import{Fragment as _Fragment,jsx as _jsx}from"react/jsx-runtime";const Background=()=>{return/*#__PURE__*/_jsx(_Fragment,{})// <div className={styles.backgroundwrapper}>
//     <div className={styles.backgroundnew} data-mode="landing">
//         <svg
//             className={styles.svgOrange}
//             xmlns="http://www.w3.org/2000/svg"
//             fill="none"
//             viewBox="-121 0 1058 679"
//         >
//             <path
//                 d="M249.184 266.995c-29.575 143.703-288.358 27.372-363.118 211.449s460.059 242.927 830.571 170.391S934.344 67.179 668.988 11.067 278.759 123.292 249.184 266.995"
//                 fill="#943E00"
//             />
//         </svg>
//         <svg
//             className={styles.svgYellow}
//             xmlns="http://www.w3.org/2000/svg"
//             fill="none"
//             viewBox="0 0 641 577"
//         >
//             <path
//                 d="M356.384 324.954C255.005 319.07 57.236 270.497 5.481 397.916s275.285 275.421 465.08 95.711C684.228 291.315 695.177-43.413 513.673 4.665c-87.646 23.216-76.242 324.993-157.289 320.289"
//                 fill="#F5D90A"
//             />
//         </svg>
//         <svg
//             className={styles.svgRed}
//             xmlns="http://www.w3.org/2000/svg"
//             fill="none"
//             viewBox="220.17 220.71 786.69 500.19"
//         >
//             <path
//                 d="M605.402 608.659C735.171 618.151 731.417 771.899 893.742 703.355 1056.07 634.811 1074.93 230.523 740.163 221.372 363.294 211.071 243.605 320.624 220.544 560.096 211.085 658.321 381.805 592.304 605.402 608.659Z"
//                 fill="#AA2429"
//             />
//         </svg>
//     </div>
// </div>
;};export default Background;